module.exports = __webpack_public_path__ + "img/1576012227.0d554a8f.jpg";